module.exports = __webpack_public_path__ + "static/img/lanya.0b17ac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/mobile/lanya.png
// module id = mZZJ
// module chunks = 12